import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { Button, Col, DatePicker, Flex, Modal, Row, Select } from "antd";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { useSelector } from "react-redux";
import { productCategories, productSubcategories } from "../../Components/common/Constants";
import { showMessage } from "../../Components/Utils/message";
import { PicCenterOutlined, ProductOutlined, SnippetsOutlined, UserOutlined } from "@ant-design/icons";
import InputBox from "../../Components/common/InputBox";
import { decodeId } from "../../Components/common/CommonFun";

const DataSheet = styled('div')`
   .ant-input-number-disabled {
      background: none;
      color: black;
    }
    .ant-picker-outlined.ant-picker-disabled {
        background: white;
        color: black;
    }
    .ant-picker-outlined.ant-picker-disabled  .ant-picker-input > input {
        color: black;
    }
`;
const Auth = new AuthService();

export default function CycleCount(props) {
  const { Option } = Select;

  const navigate = useNavigate();
  const params = useParams();
  const decodedID = decodeId(params?.id)

  var layoutDispatch = useLoadingDispatch();
  const { products } = useSelector((state) => state.AppState?.userCreds);
  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  const [selectedProducts, setSelectedProducts] = React.useState([]);
  const [countDate, setCountDate] = React.useState(dayjs());
  const [notes, setNotes] = React.useState("");
  const [assignee, setAssignee] = React.useState(null);
  const [helpers, setHelpers] = React.useState([]);
  const [productFilters, setProductFilters] = React.useState({
    category: null,
    sub_category: [],
    filteredProducts: [],
    filteredSubCategories: [],
  });

  const [progress, setProgress] = React.useState({
    is_updated: false,
    posted: false,
  });

  const getCountCycleByID = async () => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/cycle-count?id=${id}`);
      if (res?.ack) {
        setCountDate(res?.cycle_count.count_date ? dayjs(res?.cycle_count.count_date, 'YYYY-MM-DD') : null);
        setNotes(res?.cycle_count.notes);
        const sub = JSON.parse(res?.cycle_count.sub_category);
        const filteredByCategory = products.filter((item) => item.category === res?.cycle_count.category);
        console.log('filteredByCategory', filteredByCategory);
        
        // const filteredProducts = filteredByCategory.filter((item) => sub.includes(item.sub_category));
        // const subCategories = productSubcategories.filter(item => item.Category === res?.cycle_count.category);
        console.log(res?.cycle_count.category);
        
        setProductFilters({
          ...productFilters,
          category: res?.cycle_count.category,
          sub_category: sub,
          // filteredProducts: filteredProducts,
          filteredProducts: filteredByCategory,
          // filteredSubCategories: subCategories,
        });
        setProgress({
          is_updated: res?.wms_cycle_count_items_quantities?.length > 0 ? true : false,
          posted: res?.cycle_count.posted_by > 0 ? true : false,
        });

        const matchedProducts = filteredByCategory
          ?.filter(prod =>
            res.wms_cycle_count_items.some(item => item.product_netsuite_id === prod.netsuite_id)
          )
        setSelectedProducts(matchedProducts);

      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      hideLoading(layoutDispatch);
    }
  }

  React.useEffect(() => {
    if (id > 0) {
      getCountCycleByID();
    }
  }, [id]);

  const getAllHelpers = async () => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/helper/warehouse-helpers`);
      if (response) {
        hideLoading(layoutDispatch);
        if (response?.ack) {
          setHelpers(response.warehouse_helpers);
        } else {
          setHelpers([])
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  React.useLayoutEffect(() => {
    getAllHelpers();
  }, [])


  const onChangeProduct = (values) => {
    const selected = products.filter(product => values.includes(product.netsuite_id));
    setSelectedProducts(selected);
  }

  console.log('filters', productFilters);


  const submitCountCycle = async () => {
    if (!productFilters?.category) {
      showMessage('error', "Please select a category");
      return;
    }
    // if (!productFilters?.sub_category?.length) {
    //   showMessage('error', "Please select a sub category");
    //   return;
    // }
    if (!selectedProducts.length) {
      showMessage('error', "Please select a product");
      return;
    }
    showLoading(layoutDispatch);

    const isUpdate = id > 0;
    const dataToSend = {
      wms_cycle_count_items: selectedProducts?.map(product => ({
        product_netsuite_id: product?.netsuite_id,

      })),
      category: productFilters?.category,
      // sub_category: JSON.stringify(productFilters?.sub_category),
      notes: notes,
    };
    if (!isUpdate) {
      dataToSend.count_date = countDate ? dayjs(countDate).format("YYYY-MM-DD") : null
    } else {
      dataToSend.id = id;
    }
    const method = id > 0 ? "PUT" : "POST";
    try {
      const res = await Auth.fetch(`/stock/cycle-count`, {
        method: method,
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        showMessage('success', res?.message);
        navigate("/cycle-counts");
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleChangeDate = (date) => {
    setCountDate(date);
  }

  console.log('productFileter', productFilters);
  

  const categoryItem = {
    label: "Category",
    value: productFilters?.category,
    options: productCategories,
    onChange: (value) => {
      const subcategroies = productSubcategories.filter((item) => item.Category === value);
      const categoryFilteredProducts =  products.filter((item) => item.category === value)
      setProductFilters({
        ...productFilters,
        category: value,
        // sub_category: null,
        filteredSubCategories: subcategroies,
        filteredProducts: categoryFilteredProducts || []
      });
      setSelectedProducts([])
    },
    icon: <PicCenterOutlined style={{ color: "#13c2c2" }} />,
    readOnly: false,
    type: 'select',
    data: 'constants'
  }
  // const subCategoryItem = {
  //   label: "Sub Category",
  //   value: productFilters?.sub_category || [],
  //   options: productFilters?.filteredSubCategories,
  //   onChange: (selectedValues) => {
  //     console.log(selectedValues);

  //     const prevSelected = productFilters?.sub_category || [];
  //     const removedSubCategories = prevSelected.filter(sub => !selectedValues.includes(sub));

  //     const category = productFilters?.category;
  //     const categoryFilteredProducts = category
  //       ? products.filter((item) => item.category === category)
  //       : [];
  //     console.log(categoryFilteredProducts);

  //     const finalFilteredProducts = selectedValues?.length
  //       ? categoryFilteredProducts.filter((item) =>
  //         selectedValues?.includes(item.sub_category)
  //       )
  //       : [];
  //     console.log('filtered products', categoryFilteredProducts.filter((item) =>
  //       selectedValues?.includes(item.sub_category)
  //     ));

  //     const updatedSelectedProducts = selectedProducts.filter(
  //       (prod) => !removedSubCategories.includes(prod.sub_category)
  //     );
  //     setSelectedProducts(updatedSelectedProducts);
  //     setProductFilters({
  //       ...productFilters,
  //       sub_category: selectedValues,
  //       filteredProducts: finalFilteredProducts,
  //     });

  //   },
  //   icon: <PicCenterOutlined style={{ color: "#13c2c2" }} />,
  //   readOnly: false,
  //   type: 'select-multiple',
  //   data: 'sub_categories'
  // }
  const productItem = {
    label: "Product",
    value: selectedProducts?.map(item => item.netsuite_id),
    options: productFilters?.filteredProducts,
    onChange: (values) => onChangeProduct(values),
    icon: <ProductOutlined style={{ color: "#1677ff" }} />,
    readOnly: false,
    type: 'select-multiple',
    data: 'products',
  }
  const assigneeItem = {
    label: "Assignee",
    value: assignee,
    options: helpers,
    onChange: (value) => { setAssignee(value) },
    icon: <UserOutlined style={{ color: "#13c2c2" }} />,
    readOnly: false,
    type: 'select',
    data: 'helper'
  }
  const notesItem = {
      label: 'Notes',
      value: notes,
      onChange: (val) => setNotes(val),
      readOnly: false,
      type: 'notes',
      icon: <SnippetsOutlined style={{ color: "#1677ff" }} />
    };

  return (
    <DataSheet>
      <h1> {id > 0 ? "Update" : "Add"} Cycle Count </h1>
      <DatePicker
        format={"DD-MM-YYYY"}
        value={countDate}
        onChange={(date) => {
          handleChangeDate(date ? dayjs(date, 'YYYY-MM-DD') : null);
        }}
        style={{
          width: "200px",
          marginBottom: "20px",
        }}
        placeholder="Select date"
        disabled={progress?.posted}
      />
      <Row gutter={16}>
        <Col xs={24} sm={12} md={12} lg={8} xl={8}>
          <InputBox inputItem={categoryItem} inputType='select' />
        </Col>
        {/* {
          productFilters?.category && (
            <Col xs={24} sm={24} md={24} lg={16} xl={16}>
              <InputBox inputItem={subCategoryItem} inputType='select' />
            </Col>
          )
        } */}
      </Row>
      <Row >
        {productFilters?.filteredProducts?.length > 0 &&
          <Col span={24}>
            <InputBox inputItem={productItem} inputType='select' />
          </Col>
        }
      </Row>
      <Row >
        {selectedProducts?.length > 0 &&

          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <InputBox inputItem={assigneeItem} inputType='select' />
          </Col>
        }
      </Row>
      <Row style={{ marginTop: "20px" }} gutter={16}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12}>
        <InputBox inputItem={notesItem} inputType='notes' />
          {/* <span>
            Notes:
          </span>
          <TextArea value={notes} onChange={(e) => setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} /> */}
        </Col>
      </Row>
      <Flex justify="end" gap={5}>
        <Button onClick={() => navigate('/cycle-counts')}>Cancel</Button>
        {
          !progress?.posted && (
            <>
              {
                progress?.is_updated ? (
                  <Button type="primary" onClick={() => {
                    Modal.confirm({
                      title: 'Confirm Save',
                      content: 'Are you sure you want to save? This will overwrite all previously completed cycle count progress.',
                      onOk: () => submitCountCycle(),
                      okText: 'Yes',
                      cancelText: 'No',
                      centered: true,
                    });
                  }}
                  >Save</Button>
                ) : (
                  <Button type="primary" onClick={submitCountCycle}>Save</Button>
                )
              }
            </>
          )
        }
      </Flex>
    </DataSheet>
  );
}
